<template>
  <div v-if="useWrapper" :class="`form-ant-checkbox-wrapper${wrapperClass ? ` ${wrapperClass}` : ''}`" data-type="checkbox">
    <a-checkbox-group
      v-if="_options && (_options.length > 0 || (typeof _options === 'object' && Object.keys(_options).length > 0))"
      v-bind="$attrs"
      v-model:value="_value"
      :options="_options"
    />
    <a-checkbox v-else v-bind="$attrs" :value="$attrs?.value || _value" v-model:checked="_value">
      {{ $attrs?.label || '' }}
    </a-checkbox>
  </div>
  <template v-else>
    <a-checkbox-group
      v-if="_options && (_options.length > 0 || (typeof _options === 'object' && Object.keys(_options).length > 0))"
      v-bind="$attrs"
      v-model:value="_value"
      :options="_options"
    />
    <a-checkbox v-else v-bind="$attrs" :value="$attrs?.value || _value" v-model:checked="_value">
      {{ $attrs?.label || '' }}
    </a-checkbox>
  </template>
</template>

<script>
export default {
  name: 'FormAntdCheckbox',
  inheritAttrs: false,
  components: {},
  props: {
    /**
     * Value bound via v-model.
     */
    modelValue: {
      type: [String, Number, Object, Array, Boolean],
      default: ''
    },
    /**
     * This can be an array of values, array of objects or an object.
     */
    options: [Object, Array],
    /**
     * Use Wrapper.
     */
    useWrapper: {
      type: Boolean,
      default: false
    },
    /**
     * Additional classes for the wrapper.
     */
    wrapperClass: {
      type: String,
      default: ''
    }
  },
  emits: ['update:modelValue'],
  computed: {
    _value: {
      get() {
        return this.modelValue
      },
      set(value) {
        this.returnValue(value)
      }
    },
    _options() {
      let options = this.options
      if (Array.isArray(this.options) && (typeof this.options[0] == 'string' || typeof this.options[0] == 'number')) {
        options = this.options.map((item, i) => {
          return { value: item.toString(), label: item.toString(), id: `${item.toString().trim()}-${i}` }
        })
      } else if (Array.isArray(this.options) && !this.options[0].id) {
        options = this.options.map((item, i) => {
          return { ...item, id: `${item.value.toString().trim()}-${i}` }
        })
      } else if (typeof this.options === 'object') {
        options = Object.keys(this.options).map((item, i) => ({
          value: item,
          label: this.options[item].toString().trim(),
          id: `${this.options[item].toString().trim()}-${i}`
        }))
      }
      return options
    }
  },
  methods: {
    returnValue(value) {
      // emit updateModel value
      this.$emit('update:modelValue', value)
      if (this.$attrs.onUpdateModelValue && typeof this.$attrs.onUpdateModelValue === 'function') {
        this.$attrs.onUpdateModelValue(value)
      }
    }
  }
}
</script>

<style lang="postcss" scoped></style>
